// extracted by mini-css-extract-plugin
module.exports = {"cls1":"contacts-Link-module--cls1--2X81X","cls2":"contacts-Link-module--cls2--1nhCv contacts-Link-module--cls1--2X81X"};